module.exports = __webpack_public_path__ + "static/it-70b16a0d8497608ec9d97e5490598c64.png";